export { backgroundStyleFromVisualConfig } from './bg-style-from-visual-config';
